import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonImg,
  IonPage,
  IonProgressBar,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { useContext, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import NotificationBadgeButton from '../../../components/NotificationBadgeButton';
import { AppContext } from '../../../lib/context/AppContext';
import { Announcement, IAnnouncement } from '../../../lib/models';
import PageContainer from '../../../components/PageContainer';

interface UserDetailPageProps
  extends RouteComponentProps<{
    announcementId: string;
  }> {}

const NewsDetailsPage: React.FC<UserDetailPageProps> = ({ match }) => {
  const { apiService } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);
  const [announcement, setAnnouncement]: [IAnnouncement | undefined, any] =
    useState();

  const fetchAnnouncement = () => {
    apiService
      ?.get(
        `/announcements/${match.params.announcementId}?populate=media,address`
      )
      .then(
        (response: any) => {
          setAnnouncement(Announcement(response.data.data));
          setIsLoading(false);
        },
        (error) => {
          setIsLoading(false);
        }
      );
  };

  useEffect(() => {
    if (!announcement) {
      setIsLoading(true);
      fetchAnnouncement();
    }
  }, [apiService]);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color='primary'>
          {isLoading && <IonProgressBar type='indeterminate'></IonProgressBar>}
          <IonButtons slot='start'>
            <IonBackButton
              defaultHref='/news'
              text={'Indietro'}
            ></IonBackButton>
          </IonButtons>
          <IonTitle>Dettaglio News</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {announcement?.media?.data?.attributes?.url && (
          <IonImg src={announcement?.media?.data?.attributes?.url}></IonImg>
        )}
        {announcement && (
          <PageContainer>
            <h1>{announcement?.title}</h1>
            <div className='mt-4 flex items-center'>
              <span className='font-bold'>
                {new Date(announcement?.publishedAt).toLocaleDateString()}
              </span>
            </div>
            <div className='border-top w-full h-[1px] bg-gray-300 my-4'></div>
            <div
              className='pb-4'
              dangerouslySetInnerHTML={{
                __html: announcement?.description || '',
              }}
            ></div>
          </PageContainer>
        )}
      </IonContent>
    </IonPage>
  );
};
export default NewsDetailsPage;
